import React, { useState, useRef, useEffect } from 'react';
import { TemplateWrapper, Title, Description, ButtonWrapper } from './style.js';
import '../../Assignments/Base/style.js';
import '../../Assignments/Box/style.js';
import '../../Assignments/Detail/style.js';
import '../../SVGWrapper/style.js';
import '../../Badge/components/level0.js';
import '../../Badge/components/index.js';
import Button from '../../Button/index.js';
import '../../Control/Checkbox/style.js';
import '../../Control/Radio/style.js';
import '../../Control/BoxRadio/index.js';
import '../../Control/SegmentedControl/index.js';
import '../../Control/Switch/style.js';
import '../../Divider/style.js';
import 'react-dom';
import '../../Dropdown/style.js';
import Icon from '../../Icon/index.js';
import '../../Dropdown/Item/style.js';
import '../index.js';
import '../../ProgressBar/style.js';
import 'styled-components';
import '../../theme/index.js';
import 'react-indiana-drag-scroll';
import '../../Tab/style.js';
import '../../Tag/style.js';
import '../../Input/Input/style.js';
import '../../Input/Input/types.js';
import '../../Description/index.js';
import '../../Input/FormField/style.js';
import '../../Input/Textarea/style.js';
import '../../Toast/Toast.js';
import '../../Vocabulary/style.js';
import '../../Select/style.js';
import '../../Pagination/style.js';
import 'react-popper';
import '../../Tooltip/style.js';

var iconStyle = { marginBottom: '0.8rem' };
var icon = {
    vertical: React.createElement(Icon.State, { styleType: "check", size: "large", style: iconStyle }),
    success: React.createElement(Icon.State, { styleType: "check", size: "large", style: iconStyle }),
    confirm: React.createElement(Icon.State, { styleType: "info", size: "large", style: iconStyle }),
    warning: React.createElement(Icon.State, { styleType: "danger", size: "large", style: iconStyle }),
};
function Template(_a) {
    var styleType = _a.styleType, Icon = _a.Icon, title = _a.title, description = _a.description; _a.inputId; _a.inputLabel; var onCancelLabel = _a.onCancelLabel, onCancel = _a.onCancel, onConfirmLabel = _a.onConfirmLabel, onConfirm = _a.onConfirm;
    var _d = useState(''); _d[0]; _d[1];
    var _e = useState(styleType === 'vertical'), isVertical = _e[0], setIsVertical = _e[1];
    var buttonWrapperRef = useRef();
    var showInput = styleType === 'vertical' || styleType === 'input';
    useEffect(function () {
        var _a;
        var buttonWrapperHeight = ((_a = document.querySelector('.button-wrapper')) === null || _a === void 0 ? void 0 : _a.clientHeight) || 0;
        setIsVertical(buttonWrapperHeight > 53);
    }, []);
    return (React.createElement(TemplateWrapper, { showInput: showInput, vertical: isVertical },
        Icon || icon[styleType],
        React.createElement(Title, null, title),
        React.createElement(Description, null, description),
        React.createElement(ButtonWrapper, { ref: buttonWrapperRef, className: "button-wrapper" },
            typeof onCancelLabel === 'string' && onCancel && (React.createElement(Button, { onClick: onCancel }, onCancelLabel)),
            styleType !== 'success' && (React.createElement(Button, { className: "confirm", styleType: styleType === 'warning' ? 'danger' : 'primary', onClick: onConfirm }, onConfirmLabel)))));
}

export { Template as default };
